export default __webpack_public_path__ + "static/erich-fischer-1993-54ccf6c9065d58416added55a4ce498d.jpg";